<template>
  <ul class="ml-4">
    <li><b>Flow length</b>: {{ alarm.$flowLengthReadable }}</li>
    <li v-if="alarm.$flowDataAggWindowReadable">
      <b>Period:</b> {{ alarm.$flowDataAggWindowReadable }}
    </li>
  </ul>
</template>

<script>
export default {
  name: "FlowDetailBlock",
  props: {
    alarm: {
      type: Object,
    },
  },
};
</script>

<style scoped></style>
